import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PersetujuanReuseSvc from "@/services/PersetujuanReuse";

const EMPTY_MASTERS = { spaulding: [], metode_sterilisasi: [], alat_master: [] };

@Module({ store, dynamic: true, namespaced: true, name: "persetujuan-reuse" })
class PersetujuanReuseModule extends VuexModule {
  items: any[] = [];
  currentItem: any = null;
  loading = false;
  masters: any = { ...EMPTY_MASTERS };

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_CURRENT_ITEM(val: any) {
    this.currentItem = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation SET_MASTERS(val: any) {
    this.masters = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanReuseSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PersetujuanReuseSvc.find(id);
      const { data } = dt.data;
      this.SET_CURRENT_ITEM(data);
    } catch {
      this.SET_CURRENT_ITEM(null);
    }
    this.SET_LOADING(false);
  }

  @Action async loadMasters() {
    if (this.masters.spaulding && this.masters.spaulding.length > 0) return;
    try {
      const dt = await PersetujuanReuseSvc.getMasters();
      this.SET_MASTERS(dt.data.data || { ...EMPTY_MASTERS });
    } catch {
      this.SET_MASTERS({ ...EMPTY_MASTERS });
    }
  }

  @Action reset() {
    this.SET_ITEMS([]);
    this.SET_CURRENT_ITEM(null);
  }
}

export const storePersetujuanReuse = getModule(PersetujuanReuseModule);
